import {
  Button,
  MenuItem,
  Stack,
  SvgIcon,
  TextField,
  Typography,
  Box,
  Avatar,
  Card,
  Grid,
  Switch,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useLocation, useNavigate } from 'react-router';
import FormControlLabel from '@mui/material/FormControlLabel';
import { paths } from 'src/paths';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import MedicalDetails from './medicalDetails';
import { useRouter } from 'src/hooks/use-router';
import { useDispatch, useSelector } from 'react-redux';
import { disciplineType, screeningType } from 'src/redux/actions/patientScreening';
import { Container } from '@mui/system';
import { useSettings } from 'src/hooks/use-settings';
import { getSinglePatient } from 'src/redux/actions/patientAction';

const { patientDetails, screening, patients } = paths;

const AddNewScreening = () => {
  const settings = useSettings();
  const { state } = useLocation();
  const navigate = useNavigate();
  const router = useRouter();
  const [file, setFile] = useState<any>(null);
  const dispatch = useDispatch();
  const patientId = state;
  const screeningData = useSelector((state: any) => state?.getScreeningTypeReducer?.response);
  const disciplineData = useSelector((state: any) => state?.getDisciplineTypeReducer?.response);
  const getPatientId = useSelector((state: any) => state?.getPatientIdReducer);
  const patientData = useSelector((state: any) => state?.getSinglePatientReducer?.patient);

  const [screenValue, setScreenValue] = useState('');

  useEffect(() => {
    dispatch(screeningType(getPatientId));
    dispatch(disciplineType(getPatientId));
  }, [getPatientId]);

  useEffect(() => {
    dispatch(
      getSinglePatient({
        patientId: getPatientId,
      })
    );
  }, [getPatientId]);

  return (
    <Container maxWidth={settings.stretch ? false : 'xl'}>
      <Stack gap="1.5rem">
        <Button
          sx={{
            justifyContent: 'flex-start',
            color: '#111927',
            width: 'max-content',
            padding: '0px',
          }}
          onClick={() =>
            navigate(`${patients}/${patientDetails}${screening}`, {
              state: {
                patientId,
              },
            })
          }
          startIcon={
            <SvgIcon>
              <ArrowBackIcon sx={{ color: '#6C737F' }} />
            </SvgIcon>
          }
        >
          Back to Screening List
        </Button>
        <Stack
          flexDirection="row"
          gap="1rem"
          alignItems="center"
        >
          <Box>
            <Avatar
              sx={{
                height: 64,
                width: 64,
                border: '1px solid black',
              }}
            >
              <label
                htmlFor="file"
                style={{
                  width: '100%',
                  display: 'flex',
                  height: '100%',
                  borderRadius: '50%',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                {file && (
                  <img
                    width="100%"
                    height="100%"
                    src={URL.createObjectURL(file)}
                  />
                )}
                {!file && 'S'}
              </label>
            </Avatar>
          </Box>
          <input
            type="file"
            accept="image/*"
            onChange={(event) => setFile(event.target.files && event.target.files[0])}
            id="file"
            style={{ display: 'none', position: 'absolute' }}
          />
          <Typography variant="h4">{`${patientData?.firstName} ${patientData?.lastName} - Add New Screening`}</Typography>
        </Stack>
        <Card sx={{ padding: '1.5rem' }}>
          <Stack gap="1rem">
            <Typography variant="h6">Add Basic Details</Typography>
            <Grid
              spacing={3}
              container
            >
              <Grid
                item
                xs={6}
              >
                <TextField
                  fullWidth
                  label="Screening Type"
                  name="screeningType"
                  onChange={(selected: any) => {
                    setScreenValue(selected?.target?.value);
                  }}
                  select
                >
                  {screeningData?.map((option: any) => (
                    <MenuItem
                      key={option.key}
                      value={option.displayName}
                    >
                      {option.displayName}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid
                item
                xs={6}
              ></Grid>
              <Grid
                item
                xs={6}
              >
                <DateTimePicker
                  label="Start date"
                  onChange={() => {}}
                  value={new Date()}
                  sx={{ width: '100%' }}
                />
              </Grid>
              <Grid
                item
                xs={6}
              >
                <TextField
                  fullWidth
                  label="Discipline Of Complete"
                  name="disciplineOfComplete"
                  onChange={(selected: any) => {
                    setScreenValue(selected?.target?.value);
                  }}
                  select
                >
                  {disciplineData?.map((option: any) => (
                    <MenuItem
                      key={option.key}
                      value={option.displayName}
                    >
                      {option.displayName}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
            </Grid>
          </Stack>
        </Card>
        <Card>
          <Stack gap="1rem">
            <Stack sx={{ padding: ' 1.5rem' }}>
              <Typography variant="h6">Screening Questions</Typography>
              <Typography variant="body2">
                Indicate yes/no if there was a change (improvement or decline) observed or reported
                in the following areas
              </Typography>
            </Stack>
            <MedicalDetails title="Medical" />
            <MedicalDetails title="Mobility Screening" />
            <MedicalDetails title="Self-care" />
          </Stack>
        </Card>
        <Card>
          <Stack gap="1rem">
            <Stack sx={{ padding: ' 1.5rem' }}>
              <Typography variant="h6">Eval Details</Typography>
            </Stack>
            <Grid
              container
              display={'flex'}
              flexDirection={'row'}
              sx={{ padding: ' 1.5rem' }}
            >
              <Grid
                item
                lg={6}
              >
                <Typography variant="subtitle1">Is evaluation neccessary?</Typography>
                <Typography variant="body2">
                  Toggling means that evaluation is required for the patient
                </Typography>
              </Grid>
              <Grid
                item
                lg={6}
              >
                <FormControlLabel
                  control={<Switch color="primary" />}
                  label="Evaluation required"
                />
              </Grid>
            </Grid>
            <Grid
              container
              display={'flex'}
              flexDirection={'row'}
              sx={{ padding: ' 1.5rem' }}
            >
              <Grid>
                <Typography variant="h6">Add Eval Disciplines as per the screening done</Typography>
                <Typography variant="body2">
                  The evals can only be added from the relevant role as per the permissions
                </Typography>
              </Grid>
            </Grid>
          </Stack>
          <Stack></Stack>
        </Card>
      </Stack>
    </Container>
  );
};

export default AddNewScreening;
